import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'ui-components/buttons/Button/Button'
import Modal from 'ui-components/modals/ModalVip/ModalVip'
import { addTranslationNamespace, TranslationNamespace } from 'common/utils/translation'

import ModalMessageContent, { MessageContentProps } from './MessageContent/MessageContent'
import modalMessageEn from './ModalMessage_en.json'
import modalMessageAr from './ModalMessage_ar.json'

export type ModalMessageProps = {
  singleCloseButtonText?: string
  className?: string
  open: boolean
} & MessageContentProps

const ModalMessage: FunctionComponent<ModalMessageProps> = ({
  open,
  onClose,
  title,
  description,
  actions,
  type,
  singleCloseButtonText,
  className,
}) => {
  const { t } = useTranslation(TranslationNamespace.modalMessage)

  return (
    <Modal open={open} onClose={onClose}>
      <ModalMessageContent
        className={className}
        title={open && title}
        description={open && description}
        type={type}
        onClose={onClose}
        actions={
          open &&
          (actions || (
            <Button dataTestid='close-modal-button' onClick={onClose}>
              {singleCloseButtonText || t('ok')}
            </Button>
          ))
        }
      />
    </Modal>
  )
}
export default ModalMessage

addTranslationNamespace(TranslationNamespace.modalMessage, modalMessageEn, modalMessageAr)
